import { DataLayer } from '@alfa-bank/site-data-layer';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IDepsDesktop, TMainMenuLinkDesktop } from '../models';
import { CommonLinkDesktop as CommonLink } from '../../common-link/desktop';
import { IconChevronUp } from '../../icon-chevron-up';
import { DropDownDesktop as DropDown } from '../../drop-down/desktop';

import { MainMenuLinkDesktop as Component } from './main-menu-link-desktop';
import styles from './styles.css';

export const MainMenuLinkDesktop = createWidget<IDepsDesktop, TMainMenuLinkDesktop>({
    styles,
    CommonLink,
    DropDown,
    DataLayer,
    IconChevronUp,
})(Component);
